export const SESSION_KEYS = {
    CLIENT_CODE: "clientCode",
    PREFERENCE: "preferences",
    PREFERENCE_CHANGED: "preferenceChanged",
    GLOBAL_SETTINGS: "global",
    FNO_SYMBOL: "fno_symbols",
    dEPTH_TOKEN_RESPONSE: "depth_token_response",
    ORDERBOOK: "orderbook",
    GREEKSLIST: "greeksList",
    LISTOFINDICES: "listofindices",
    JWTTOKEN: "jwtToken",
    COOKIE: "5pCookie",
    NAME: "ClientName",
    MARKETDEPTHTOKEN: "MarketDepthToken",
    THEME: "theme",
    USERMARKETENABLED: "userMarketEnabled",
    PLAN_ID: "PlanID",
    FIVEPAISACOOKIES: "fivePaisaCookies",
    SMART_ALGO_KEY: "SmartAlgoKey",
    SCRIP_DATA: "scripData",
    USERIGHTS: "userRights",
    FNO_EXPIRY: "fno_exiry_",
    FNO_OPTIONS: "fno_options_",
    LOGIN_TIME: "loginTime",
    CHECK_FIREBASE_POLLING: "check_fire_base_polling",
    WS_ERROR: "ws-error",
    LOGGLY_CLIENT: "logglyClient",
    SOLACE_CLIENT: "solaceClient",
    SOLACE_ENABLED: "solaceEnabled",
    NOTIFICATION_LAST_TIME: "notificationLastTime",
    NOTIFICATION_OPEN_TIME: "notificationOpenTime",
    SOLACE_ERROR: "solaceError",
    ORDER_SETTINGS: "orderSettings",
    DEPTH_PIN: "depthPin",
    REQUEST_COOKIE: "requestCookie",
    HOST_NAME: "HOST_NAME",
    SOLACE_TIMER: "solaceTimer",
    FIREBASE_LOGIN_URL: "Firebase_login_url",
    GUESTLOGIN_COOKIE: "guestlogincookie"
};
let sessionData;
export const writeData = () => {
    localStorage.setItem("sessionData", JSON.stringify(sessionData));
};
export const clearSessionData = (clearLocalStorage) => {
    sessionData = {};
    if (clearLocalStorage) {
        Object.keys(localStorage).forEach((key) => {
            if (!(key.includes("apx_") ||
                key.includes("0_") ||
                key.includes("1_") ||
                key.includes("qe_"))) {
                localStorage.removeItem(key);
            }
        });
        // localStorage.clear();
        // Apxor.clearLocalStorage();
    }
};
export const clearStorageAndSetTime = () => {
    clearSessionData(true);
    window.location.reload();
};
export const setSessionData = (localDataString) => {
    if (localDataString == undefined ||
        localDataString == null ||
        localDataString.length == 0) {
        sessionData = {};
    }
    else {
        sessionData = JSON.parse(localDataString);
    }
};
export const getDataFromSession = (keyName) => {
    return sessionData[keyName];
};
export const removeFromSession = (keyName, writeDataValue) => {
    const isDataDeleted = delete sessionData[keyName];
    if (isDataDeleted && writeDataValue) {
        writeData();
    }
    return isDataDeleted;
};
export const setDataInSession = (keyName, inputValue, writeDataValue) => {
    sessionData[keyName] = inputValue;
    if (writeDataValue) {
        writeData();
    }
};
export const getCompleteSessionData = () => {
    return sessionData;
};
